export enum ExternalCompanyMetricsState {
  INIT,
  EMPTY,
  PASSWORD,
  AUTHORIZED
}

export class ExternalCompanyMetricsStateWrapper {
  current: ExternalCompanyMetricsState = ExternalCompanyMetricsState.INIT;
  all: typeof ExternalCompanyMetricsState = ExternalCompanyMetricsState;
}

export enum ExternalCompanyMetricsTabs {
  Actual = 'Actual',
  Budget = 'Budget',
  // CompanyUpdates = 'Company Updates',
  SubmitData = 'Submit Data',
}
export class ExternalCompanyMetricsTabsWrapper {
  all: ExternalCompanyMetricsTabs[] = [ExternalCompanyMetricsTabs.Actual,
    ExternalCompanyMetricsTabs.Budget,
    // ExternalCompanyMetricsTabs.CompanyUpdates,
    ExternalCompanyMetricsTabs.SubmitData];

  selected: ExternalCompanyMetricsTabs = ExternalCompanyMetricsTabs.Actual;
  isActualSelected = true;
}

export interface ExternalCompanyMetricsShow{
  modalBulkUpload: boolean;
  saveDialog: boolean;
  modalAfterSuccessfulSubmission: boolean;
  captchaV2: boolean;
}
